import CmsBlock from "@/helpers/editor/blocks/CmsBlock.js";
import CmsBlockColumns from "@/helpers/editor/blocks/CmsBlockColumns.js";
import CmsBlockTextAndImage from "@/helpers/editor/blocks/CmsBlockTextAndImage.js";

export default class CmsBlockColumn extends CmsBlock {
    static typeDef = {
        name: `Column|Colonne`,
        type: `column`,
        category: `layout`,
        glyph: `fa-bars`,
        isParent: true,
        hidden: true
    }

    get maxChildren() {
        return 20;
    }

    get parentClasses() {
        return [CmsBlockColumns];
    }

    constructor(data, page) {
        super(data, page);

        if (this.span == null) {
            this.span = 1;
        }

        const devices = [`mobile`, `tablet`, `kiosk`];
        for (let d of devices) {
            if (!this.mediaQuery[d].hasOwnProperty(`span`)) {
                this.mediaQuery[d].span = this.span;
            }
        }

        if (!data) {
            // let block = new CmsBlockTextAndImage();
            // block.layout = `default`;
            // this.addChild(block);
        }
    }
}
